// extracted by mini-css-extract-plugin
export default {"wrap":"StatisticBySchool_wrap__u4Bp5"};